<div *ngIf="!selectedGroup">
  <input
    class="input-legacy"
    type="text"
    placeholder="{{ 'MAINTENANCES.USER_GROUPS_PLACEHOLDER' | translate }}"
    [matAutocomplete]="auto"
    [(formControl)]="inputValue"
  />

  <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="setSelectedGroup()">
    <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
    <mat-option *ngFor="let group of groups" [matTooltip]="group.name" [matTooltipShowDelay]="500" [value]="group.id">
      {{ group.name }}
    </mat-option>
    <mat-option *ngIf="!groups.length">
      {{ 'MAINTENANCES.USER_GROUPS_NOT_FOUND' | translate }}
    </mat-option>
  </mat-autocomplete>
</div>

<div class="selected-input" *ngIf="selectedGroup">
  <input class="input-legacy" type="text" disabled [value]="selectedGroup.name" />

  <button mat-icon-button class="cancel-button" *ngIf="selectedGroup" (click)="deselectGroup()">
    <mat-icon>cancel</mat-icon>
  </button>
</div>
